{
  "mySystems": {
    "title": "My Systems",
    "description": "Software systems you are responsible for and manage.",
    "empty": "You don't manage any software systems in your organization."
  },
  "systemLandscape": {
    "title": "System Landscape",
    "view": {
      "list": "List",
      "2d": "2D",
      "3d": "3D"
    },
    "kpi": {
      "systems": "Systems",
      "systemsDesc": "Total active systems",
      "connections": "Connections",
      "connectionsDesc": "System-to-system interactions",
      "avgConnections": "Avg. Connections",
      "avgConnectionsDesc": "Per system",
      "isolated": "Isolated Systems",
      "isolatedDesc": "Systems without connections",
      "mediaBreaks": "Media Breaks",
      "mediaBreaksDesc": "System transition breaks"
    },
    "list": {
      "connections": "Connections",
      "mediaBreaks": "Media Breaks"
    },
    "tooltip": {
      "upstream": "Receives from",
      "downstream": "Sends to",
      "interactionCount": "{{count}} interactions"
    },
    "navInfo": "Left-click: rotate · Mouse wheel: zoom · Right-click: pan"
  },
  "shadowSystems": {
    "title": "Shadow Systems",
    "description": "Software employees rely on in completed process recordings but which was declined for the official catalog — your shadow IT, made visible.",
    "search": "Search shadow systems...",
    "empty": "No shadow systems — all software referenced in completed recordings is sanctioned.",
    "stats": {
      "shadowSystems": "Shadow systems",
      "recordingsAffected": "Completed recordings affected"
    },
    "columns": {
      "system": "System",
      "category": "Category",
      "url": "Link",
      "openLink": "Open external link",
      "occurrences": "Occurrences",
      "suggestedBy": "Suggested by",
      "submittedAt": "Suggested on",
      "reviewedBy": "Declined by",
      "reviewedAt": "Declined on",
      "rejectionReason": "Decline reason",
      "source": "Source"
    },
    "actions": {
      "resolve": "Resolve",
      "resolved": "Shadow system resolved"
    },
    "resolveDialog": {
      "title": "Resolve shadow system",
      "description": "Description",
      "useExisting": "Merge into existing",
      "createNew": "Create new System",
      "targetSystem": "Target system",
      "selectSystem": "Select a system",
      "name": "Name",
      "systemOwner": "System Owner",
      "selectOwner": "Select an owner",
      "category": "Category",
      "url": "Link"
    }
  }
}
